module.exports = __webpack_public_path__ + "static/media/br.a30c10f8.svg";